import localScaleManager from "../../../../helpers/LocalScaleManager";

export class DealerChip extends Phaser.GameObjects.Image {
  constructor(scene, table) {
    super(scene, 0, 0, scene.atlasTexture, "d");
    this.scene = scene;
    this.table = table;
    this.setOrigin(0);
    this.scene.add.existing(this);
    this.depth = this.table.depth+1
    this.table.poolArray.push(this);
  }
  visibilityControls(visibility) {
    if (this.visible !== visibility) this.setVisible(visibility);
  }
  positionControls(size, x, y) {
    localScaleManager.scaleSprite(this, size, size, 0, 1, true);
    this.setPosition(x, y);
  }
  reposition(size, x, y) {
    this.setPosition(x, y);
  }
  remove() {
    this.destroy();
  }
}
